import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import CalendarManagementTable from './components/CalendarManagementTable';

const CalendarManagementTablePage = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Calendar Manager</h3>
        <h3 className="page-subhead subhead">Calendar Items By End Date Descending</h3>
      </Col>
    </Row>
    <Row>
      <CalendarManagementTable />
    </Row>
  </Container>
);

export default CalendarManagementTablePage;
